import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { InquiryInbox } from "../components/InquiryInbox";

export default function StaffInquiries() {
  return <div className="max-w-5xl mx-auto px-5 py-12">
    <Link data-testid="inquiries-back-to-staff" to="/staff" className="inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-orange-600 transition-colors"><ArrowLeft className="w-4 h-4" />Staff panel</Link>
    <h1 data-testid="staff-inquiries-heading" className="font-display text-4xl sm:text-5xl font-bold mt-6 mb-10">Inquiries</h1>
    <InquiryInbox />
  </div>;
}